export * from './organization';
export * from './billing';

export const PRODUCTS_SORT_BY: any = {
  GTIN: 'gtin',
  LAST_ACTION_DATE: 'lastActionDate',
  NAME: 'name',
  UPDATED_AT: 'updatedAt',
};

export const SORT_ORDER: any = {
  ASC: 'asc',
  DESC: 'desc',
};
